"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const TopMenu_1 = __importDefault(require("../TopMenu"));
const ApplicationContext_1 = require("../../context/ApplicationContext");
const { Title } = antd_1.Typography;
const ZenithHeader = () => {
    const { setCurrentTab } = (0, ApplicationContext_1.useApplicationContext)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, Object.assign({ className: 'logo-container', to: '/configurations', onClick: () => setCurrentTab('configurations') }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Image, { src: 'https://cdn.horizon.lextegrity.com/assets/logos/lextegrity-icon-64px.png', preview: false, width: 30 }), (0, jsx_runtime_1.jsx)(Title, Object.assign({ level: 4, style: { margin: 0, color: 'var(--white)' } }, { children: "Zenith" }))] })), (0, jsx_runtime_1.jsx)(TopMenu_1.default, {})] }));
};
exports.default = ZenithHeader;
